import React from 'react'
import Box from '@material-ui/core/Box'
import AttachMoneyIcon from 'components/material-symbol/icons/AttachMoney'
import AccountRouterLink from 'components/account-router-link'
import SectionEmptyState from 'components/section-empty-state'
import { TonalButton } from 'components/empty-page-state'
import useStyles from './styles'

const NoPaymentAccounts = ({ errors, isVirtualCoaching = false }) => {
  const styles = useStyles()

  return (
    <>
      <SectionEmptyState
        Icon={AttachMoneyIcon}
        title="No Payment Account"
        caption="You currently do not have a payment account set up."
        bordered={false}
        action={
          <TonalButton
            component={AccountRouterLink}
            to="/account/payments/payment-accounts"
          >
            Add Payment Account
          </TonalButton>
        }
      />
      {errors?.message ? (
        <Box className={styles.warningWrapper}>
          It is required to have a payment account in order to offer{' '}
          {isVirtualCoaching ? 'virtual coaching' : 'lesson packs'}.
        </Box>
      ) : null}
    </>
  )
}

export default NoPaymentAccounts
